// Koreman Wishlist — localStorage based
(function() {
  const KEY = 'wi_wishlist';

  const getList = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
  };

  const saveList = (list) => localStorage.setItem(KEY, JSON.stringify(list));

  const isInList = (id) => getList().some(p => String(p.id) === String(id));

  const toggle = (product) => {
    let list = getList();
    const idx = list.findIndex(p => String(p.id) === String(product.id));
    if (idx > -1) { list.splice(idx, 1); }
    else { list.push(product); }
    saveList(list);
    return idx === -1; // true = added
  };

  const getCount = () => getList().length;

  // ── Update all heart buttons on page ──
  const updateButtons = () => {
    document.querySelectorAll('[data-wi-wish]').forEach(btn => {
      const id = btn.getAttribute('data-product-id');
      if (isInList(id)) btn.classList.add('wi-wishlisted');
      else btn.classList.remove('wi-wishlisted');
    });
    updateCounters();
  };

  const updateCounters = () => {
    const count = getCount();
    document.querySelectorAll('.wi-wish-count').forEach(el => {
      el.textContent = count;
      el.style.opacity = count > 0 ? '1' : '0';
    });
  };

  // ── Global click handler for product/collection pages ──
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wi-wish]');
    if (!btn) return;
    e.preventDefault();

    const product = {
      id:    btn.getAttribute('data-product-id'),
      vid:   btn.getAttribute('data-variant-id'),
      url:   btn.getAttribute('data-product-url'),
      img:   btn.getAttribute('data-product-image'),
      title: btn.getAttribute('data-product-title'),
      price: btn.getAttribute('data-product-price')
    };

    const added = toggle(product);
    btn.classList.toggle('wi-wishlisted', added);
    updateCounters();

    // Pulse animation
    btn.classList.add('wi-wish-pulse');
    setTimeout(() => btn.classList.remove('wi-wish-pulse'), 300);
  });

  const formatMoney = (cents) => {
    if (!cents) return '';
    return '€ ' + (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };

  // ── Wishlist page rendering ──
  const renderWishlistPage = () => {
    const container = document.getElementById('wishlist_page_in');
    const emptyEl   = document.querySelector('.WI_wishlist_page_empty');
    if (!container) return;

    const list = getList();

    if (list.length === 0) {
      container.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'flex';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';

    container.innerHTML = list.map(p => `
      <div class="WI_wishlistProductCard">
        <div style="position:relative;">
          <a href="${p.url}" style="display:block;text-decoration:none;">
            <div style="width:100%;padding-bottom:130%;background:#f4f4f4;position:relative;overflow:hidden;">
              ${p.img ? `<img src="${p.img}" alt="${p.title}" style="position:absolute;inset:0;width:100%;height:100%;object-fit:contain;" loading="lazy">` : ''}
            </div>
          </a>
          <button data-wi-remove="${p.id}"
            class="wi-wish-btn wi-wishlisted" style="position:absolute;top:12px;right:12px;width:34px;height:34px;background:rgba(0,0,0,0.22);border:none;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;backdrop-filter:blur(4px);">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.45067 13.9082L11.4033 20.4395C11.6428 20.6644 11.7625 20.7769 11.9037 20.8046C11.9673 20.8171 12.0327 20.8171 12.0963 20.8046C12.2375 20.7769 12.3572 20.6644 12.5967 20.4395L19.5493 13.9082C21.5055 12.0706 21.743 9.0466 20.0978 6.92607L19.7885 6.52734C17.8203 3.99058 13.8696 4.41601 12.4867 7.31365C12.2913 7.72296 11.7087 7.72296 11.5133 7.31365C10.1304 4.41601 6.17972 3.99058 4.21154 6.52735L3.90219 6.92607C2.25695 9.0466 2.4945 12.0706 4.45067 13.9082Z" stroke="#E8C96A" fill="#E8C96A"/>
            </svg>
          </button>
        </div>
        <div style="padding-top:10px;">
          <a href="${p.url}" style="text-decoration:none;color:#111;font-size:14px;font-weight:400;display:block;margin-bottom:4px;">${p.title}</a>
          ${p.price ? `<p style="font-size:14px;color:#444;margin:0;">${formatMoney(parseInt(p.price))}</p>` : ''}
        </div>
      </div>
    `).join('');

    // Attach remove handlers directly — separate from the global data-wi-wish handler
    container.querySelectorAll('[data-wi-remove]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const id = btn.getAttribute('data-wi-remove');
        const updated = getList().filter(p => String(p.id) !== String(id));
        saveList(updated);
        updateCounters();
        renderWishlistPage();
      });
    });
  };

  // ── Init ──
  document.addEventListener('DOMContentLoaded', () => {
    updateButtons();
    renderWishlistPage();
  });

  // Export for use elsewhere
  window.WIWishlist = { getList, isInList, toggle, getCount };
})();
